import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCircleSlashComponent } from "./med-icon-circle-slash.component";

@NgModule({
  declarations: [
    MedIconCircleSlashComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCircleSlashComponent,
  ],
})
export class MedIconCircleSlashModule { }
